import { Spinner } from '@frontend/components/common';
import { NotificationContentEditorLayout } from '@frontend/notification/components';
import { FormattedMessage } from 'react-intl';

import OverviewHeader from '../../../header/overview-header';
import { useContentDetail } from './content-detail.controller';

export const ContentDetail = () => {
    const viewProps = useContentDetail();

    if (viewProps.hasError) {
        return (
            <div className='bg-background-default flex h-full flex-col items-start justify-start gap-6 self-stretch'>
                <OverviewHeader
                    key='page-title'
                    showBack
                    title={
                        <FormattedMessage
                            id='content-detail.notification-template-content'
                            description='Page title for editing notification template content'
                            defaultMessage='Notification template content'
                        />
                    }
                />
                <div className='bg-status-danger/10 text-status-danger rounded-md px-4 py-3 text-sm font-medium'>
                    <FormattedMessage
                        id='content-detail.load-error'
                        description='Error message shown when notification template content details fail to load'
                        defaultMessage='Notification template content could not be loaded.'
                    />
                </div>
            </div>
        );
    }

    if (!viewProps.template || !viewProps.content) {
        return (
            <div className='bg-background-default inline-flex flex-col items-start justify-start gap-6 self-stretch'>
                <Spinner className='text-border-default fill-brand-primary size-8' />
            </div>
        );
    }
    const readOnly = !viewProps.canUpdateNotificationTemplate;

    return (
        <div
            id='content-container'
            className='bg-background-default flex h-full flex-col items-start justify-start gap-6 self-stretch'>
            <OverviewHeader
                key='page-title'
                showBack
                title={
                    <FormattedMessage
                        id='content-detail.notification-template-content'
                        description='Page title for editing notification template content'
                        defaultMessage='Notification template content'
                    />
                }
            />
            <NotificationContentEditorLayout
                content={viewProps.content}
                placeholders={viewProps.placeholders}
                templateName={viewProps.template.name}
                onPlaceholderDrag={viewProps.onDragStart}
                onCancel={viewProps.onCancel}
                readOnly={readOnly}
            />
        </div>
    );
};
